export const FETCH_CASH_REQUISITION_DETAILS_BY_ID_REQUEST = 'FETCH_CASH_REQUISITION_DETAILS_BY_ID_REQUEST';
export const FETCH_CASH_REQUISITION_DETAILS_BY_ID_SUCCESS = 'FETCH_CASH_REQUISITION_DETAILS_BY_ID_SUCCESS';
export const FETCH_CASH_REQUISITION_DETAILS_BY_ID_FAILURE = 'FETCH_CASH_REQUISITION_DETAILS_BY_ID_FAILURE';

export const CASH_REQUISITION_DETAILS_CASHFORM_RESET = 'CASH_REQUISITION_DETAILS_CASHFORM_RESET'
export const CREATE_CASH_REQUISITION_DETAILS_FORM = 'CREATE_CASH_REQUISITION_DETAILS_FORM'

export const FETCH_CASH_REQUISITION_FORM_USING_CRFNO_REQUEST = 'FETCH_CASH_REQUISITION_FORM_USING_CRFNO_REQUEST'
export const FETCH_CASH_REQUISITION_FORM_USING_CRFNO_SUCCESS = 'FETCH_CASH_REQUISITION_FORM_USING_CRFNO_SUCCESS'
export const FETCH_CASH_REQUISITION_FORM_USING_CRFNO_FAILURE = 'FETCH_CASH_REQUISITION_FORM_USING_CRFNO_FAILURE'

export const CREATE_CASH_REQUISITION_DETAILS_FORM_REQUEST = 'CREATE_CASH_REQUISITION_DETAILS_FORM_REQUEST'
export const CREATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS = 'CREATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS'
export const CREATE_CASH_REQUISITION_DETAILS_FORM_FAILURE = 'CREATE_CASH_REQUISITION_DETAILS_FORM_FAILURE'

export const FETCH_CASH_REQUISITION_DETAILS_FORM_REQUEST = 'FETCH_CASH_REQUISITION_DETAILS_FORM_REQUEST'
export const FETCH_CASH_REQUISITION_DETAILS_FORM_SUCCESS = 'FETCH_CASH_REQUISITION_DETAILS_FORM_SUCCESS'
export const FETCH_CASH_REQUISITION_DETAILS_FORM_FAILURE = 'FETCH_CASH_REQUISITION_DETAILS_FORM_FAILURE'

export const FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_REQUEST = 'FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_REQUEST'
export const FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_SUCCESS = 'FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_SUCCESS'
export const FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_FAILURE = 'FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_FAILURE'

export const UPDATE_CASH_REQUISITION_DETAILS_FORM_REQUEST = 'UPDATE_CASH_REQUISITION_DETAILS_FORM_REQUEST';
export const UPDATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS = 'UPDATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS';
export const UPDATE_CASH_REQUISITION_DETAILS_FORM_FAILURE = 'UPDATE_CASH_REQUISITION_DETAILS_FORM_FAILURE';

export const DELETE_CASH_REQUISITION_DETAILS_FORM_REQUEST = 'DELETE_CASH_REQUISITION_DETAILS_FORM_REQUEST';
export const DELETE_CASH_REQUISITION_DETAILS_FORM_SUCCESS = 'DELETE_CASH_REQUISITION_DETAILS_FORM_SUCCESS';
export const DELETE_CASH_REQUISITION_DETAILS_FORM_FAILURE = 'DELETE_CASH_REQUISITION_DETAILS_FORM_FAILURE';

export const RESET_CASH_DETAILS_FORM_DATA = 'RESET_CASH_DETAILS_FORM_DATA';

export const BILL_UPLOAD_DATA_REQUEST = 'BILL_UPLOAD_DATA_REQUEST';
export const BILL_UPLOAD_DATA_SUCCESS = 'BILL_UPLOAD_DATA_SUCCESS';
export const BILL_UPLOAD_DATA_FAILURE = 'BILL_UPLOAD_DATA_FAILURE';

export const BILL_UPLOAD_DATA_GET_LIST_REQUEST = 'BILL_UPLOAD_DATA_GET_LIST_REQUEST';
export const BILL_UPLOAD_DATA_GET_LIST_SUCCESS = 'BILL_UPLOAD_DATA_GET_LIST_SUCCESS';
export const BILL_UPLOAD_DATA_GET_LIST_FAILURE = 'BILL_UPLOAD_DATA_GET_LIST_FAILURE';

export const VERIFY_PAYMENT_ENTRY_REQUEST = 'VERIFY_PAYMENT_ENTRY_REQUEST';
export const VERIFY_PAYMENT_ENTRY_SUCCESS = 'VERIFY_PAYMENT_ENTRY_SUCCESS';
export const VERIFY_PAYMENT_ENTRY_FAILURE = 'VERIFY_PAYMENT_ENTRY_FAILURE';